import { render, staticRenderFns } from "./PlanInfo.vue?vue&type=template&id=2a4ad8f8&"
import script from "./PlanInfo.vue?vue&type=script&lang=js&"
export * from "./PlanInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlanInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PlanInfo.vue"
export default component.exports